import React, { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
  isSelected: boolean;
  hasOffset?: boolean;
  onClick: (event: React.MouseEvent<HTMLSpanElement>) => void;
};

export const AutocompleteItem: FC<Props> = props => {
  const { className, isSelected, hasOffset, ...rest } = props;
  return (
    <li
      className={classNames('autocomplete-item', {
        'autocomplete-item--selected': isSelected,
        'autocomplete-item--offset': hasOffset,
      })}
      {...rest}
    />
  );
};
